export { default } from '../../containers/notfound/index';
export { default as getStaticProps } from '../../containers/notfound/getStaticProps';
